import { saveCartMutation } from "@/components/CartPreview/gql/mutations";
import { cartQuery } from "@/components/CartPreview/gql/queries";
import { mapCartItemToInput } from "@/utils/cartItems.mapper";

async function getApolloClient() {
  const { default: apolloClient } = await import("@/plugins/apollo-vue");

  return apolloClient;
}

export async function fetchCart() {
  const client = await getApolloClient();
  const response = await client.query({
    query: cartQuery,
    fetchPolicy: "network-only",
  });

  return response?.data?.cart;
}

export async function saveCart(cartProducts = []) {
  const items = cartProducts.map(mapCartItemToInput);

  const client = await getApolloClient();
  const response = await client.mutate({
    mutation: saveCartMutation,
    variables: { items },
  });

  return response?.data?.saveCart;
}
